import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    mvCategory: {
      id: null,
      name: undefined,
      mvs: [],
    },
    addMv: {
      id: null,
      seq: 999,
      title: undefined,
      youtubeUrl: undefined,
      image: undefined,
      description: undefined,
      startDatetime: new Date(),
      endDatetime: new Date(2999, 12, 31, 23, 59, 59),
    },
    userSearchCriteria: null, // 用來儲存3101搜尋條件
    songSearchCriteria: null, // 用來儲存4102歌曲搜尋條件
    songEditCurrentPage: null, // 用來儲存4102歌曲編輯當前頁碼
    creatorSearchCriteria: null, // 用來儲存4103創作者搜尋條件
    creatorEditCurrentPage: null, // 用來儲存4103創作者編輯當前頁碼
    albumSearchCriteria: null, // 用來儲存4104專輯搜尋條件
    albumEditCurrentPage: null, // 用來儲存4104專輯編輯當前頁碼
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    updateUserSearchCriteria(state, payload) {
      state.userSearchCriteria = { ...payload.value }
    },
    updateSongSearchCriteria(state, payload) {
      state.songSearchCriteria = { ...payload.value }
    },
    updateSongEditCurrentPage(state, payload) {
      state.songEditCurrentPage = payload.value
    },
    updateCreatorSearchCriteria(state, payload) {
      state.creatorSearchCriteria = { ...payload.value }
    },
    updateCreatorEditCurrentPage(state, payload) {
      state.creatorEditCurrentPage = payload.value
    },
    updateAlbumSearchCriteria(state, payload) {
      state.albumSearchCriteria = { ...payload.value }
    },
    updateAlbumEditCurrentPage(state, payload) {
      state.albumEditCurrentPage = payload.value
    }
  },
  actions: {},
  modules: {},
  getters: {
    getUserSearchCriteria: state => state.userSearchCriteria,
    getSongSearchCriteria: state => state.songSearchCriteria,
    getCreatorSearchCriteria: state => state.creatorSearchCriteria,
    getAlbumSearchCriteria: state => state.albumSearchCriteria
  }
})
